import FormDialog from "controls/FormDialog";
import { useActionFragment } from "hooks/useAction";
import { Plus } from "mdi-material-ui";
import React from "react";

import GameSchedulesForm from "./Form";

AddGameScheduleDialog.useButtonProps = () => {
  return {
    icon: <Plus />,
    content: "Schedule Game",
  };
};

export default function AddGameScheduleDialog({ orgId, courtId, leagueId, onSubmit, onClose }) {
  const addGameSchedule = useActionFragment("addGameSchedule", "gameSchedule { id, practice }");

  return (
    <FormDialog
      header="Add Game Schedule"
      onClose={onClose}
      onSubmit={async (formData) => {
        const result = await addGameSchedule({
          input: {
            ...formData,
          },
        });
        await onSubmit?.(result.addGameSchedule.gameSchedule);
      }}
    >
      <GameSchedulesForm
        gameSchedules={[
          {
            org: orgId && { id: orgId, __typename: "Org" },
            court: courtId && { id: courtId, __typename: "Court" },
            league: leagueId && { id: leagueId, __typename: "League" },
            practice: false,
          },
        ]}
      />
    </FormDialog>
  );
}
